import { blobWithFilename, NamedBlob } from '../../utils/fileDownload';
import { callExternalApi } from '../callExternalApi';

export type AiSummaryEntityType = 'Project' | 'Account';

export interface AiSummary {
  id: string;
  summaryText: string;
  contextLabel: string;
  generatedAt: string;
}

export type AiSummaryExport = NamedBlob;

// GET api/ai_summaries?entity_type=Project&entity_id=:id — newest-per-day snapshots, newest first.
export const getAiSummaries = async (entityType: AiSummaryEntityType, entityId?: string) => {
  if (!entityId) return { data: null, error: { message: 'Must provide an entity ID to fetch AI summaries' } };
  return await callExternalApi<AiSummary[]>({
    url: `api/ai_summaries?entity_type=${encodeURIComponent(entityType)}&entity_id=${encodeURIComponent(entityId)}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

// POST api/ai_summaries/generate — enqueues a background job (202); admin-gated by the API policy.
export const generateAiSummary = async (entityType: AiSummaryEntityType, entityId?: string) => {
  if (!entityId) return { data: null, error: { message: 'Must provide an entity ID to generate an AI summary' } };
  return await callExternalApi<{ status: string }>({
    url: 'api/ai_summaries/generate',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: {
      entity_type: entityType,
      entity_id: entityId
    }
  });
};

// GET api/ai_summaries/:id/export — the snapshot as a branded PDF, named by the API.
export const exportAiSummary = async (summaryId: string) => {
  return await callExternalApi<AiSummaryExport>({
    url: `api/ai_summaries/${encodeURIComponent(summaryId)}/export`,
    method: 'GET',
    responseType: 'blob',
    transformResponse: blobWithFilename
  });
};
